module.exports = __webpack_public_path__ + "static/commerce2x-enterprise-b7a53d49d950b7f8621a860d5df5b7dd.png";